// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2J2xaVR1ndXQ-HiN8LOHtH {\n  padding-top: 60px;\n  padding-bottom: 60px;\n}\n\n._2J2xaVR1ndXQ-HiN8LOHtH h1 {\n  max-width: 900px;\n  margin-bottom: 40px;\n  line-height: 1.1em;\n  font-size: 50px;\n}\n\n.fBy2ldq4FhO7MEe916AUf {\n  font-size: 18px;\n}\n\n@media (max-width: 695px) {\n  ._2J2xaVR1ndXQ-HiN8LOHtH h1 {\n    font-size: 23px;\n    margin: 16px 0 21px 0;\n  }\n\n  .fBy2ldq4FhO7MEe916AUf {\n    font-size: 15px;\n  }\n}\n\n._37W3-60xozYe2T0NNj2kjP {\n  margin-bottom: 32px;\n  color: gray;\n}\n\n._1uZ4heDNjJF5HvUJ_BCyH5 {\n  font-weight: 600;\n  font-size: 27px;\n  margin-bottom: 21px;\n}", ""]);
// Exports
exports.locals = {
	"demoContainer": "_2J2xaVR1ndXQ-HiN8LOHtH",
	"desc": "fBy2ldq4FhO7MEe916AUf",
	"disclaimer": "_37W3-60xozYe2T0NNj2kjP",
	"date": "_1uZ4heDNjJF5HvUJ_BCyH5"
};
module.exports = exports;
